import {
  MOCK_SCHEDULE_WEEKS,
  MOCK_STAGING_TRAY,
} from '../../_mock-data/schedule'
import type { TrayCard, Week } from '../_lib/auto-place'
import type { FilterNode } from '../_lib/filter-engine'
import { type CurriculumState, DEFAULT_TYPE_FILTER } from './contracts'

export const cloneFilterNodes = (nodes: FilterNode[]): FilterNode[] =>
  nodes.map((node) => {
    if ('rules' in node) {
      return {
        ...node,
        rules: node.rules.map((rule) => ({
          ...rule,
          value: Array.isArray(rule.value) ? [...rule.value] : rule.value,
        })),
      }
    }
    return {
      ...node,
      value: Array.isArray(node.value) ? [...node.value] : node.value,
    }
  })

const cloneWeeks = (weeks: Week[]): Week[] =>
  weeks.map((week) => ({
    ...week,
    days: week.days.map((day) => ({
      ...day,
      cards: day.cards.map((card) => ({ ...card })),
    })),
  }))

const cloneTray = (tray: TrayCard[]): TrayCard[] =>
  tray.map((card) => ({ ...card }))

const initialFilters: FilterNode[] = [
  {
    connector: 'where',
    field: 'topic',
    condition: 'contains',
    value: 'Two pointers',
  },
  { connector: 'and', field: 'elo', condition: '>', value: 2100 },
  {
    connector: 'or',
    rules: [
      {
        connector: 'where',
        field: 'topic',
        condition: 'contains',
        value: 'Binary search',
      },
      {
        connector: 'and',
        field: 'plan',
        condition: 'in plan',
        value: 'NeetCode 150',
      },
    ],
  },
]

export const createInitialState = (): CurriculumState => ({
  flash: null,
  weeks: cloneWeeks(MOCK_SCHEDULE_WEEKS),
  tray: cloneTray(MOCK_STAGING_TRAY),
  filters: cloneFilterNodes(initialFilters),
  sorts: [{ field: 'plans', dir: 'desc' }],
  typeFilter: DEFAULT_TYPE_FILTER,
  companyTags: [],
  hiddenCols: [],
  columnOrder: [],
  seenFilter: 'unseen',
  libraryTab: 'browse',
  placingId: null,
  nextId: 1,
})
